(function(){
  var lander = document.querySelector(
    '[data-stono-vsl-lander], [data-stono-branded-search-lander]'
  );

  if (!lander || !document.body || !('MutationObserver' in window)) return;

  var body = document.body;
  var html = document.documentElement;

  function releaseOrphanedAliaLock(){
    var alia = document.querySelector('[id^="alia-root-"]');
    var themeHasLockedScroll = html.classList.contains('scroll-locked') ||
      body.getAttribute('data-scroll-lock-locked') === 'true';

    if (alia && body.style.overflow === 'hidden' && !themeHasLockedScroll) {
      body.style.removeProperty('overflow');
    }
  }

  releaseOrphanedAliaLock();

  new MutationObserver(releaseOrphanedAliaLock).observe(body, {
    attributes: true,
    attributeFilter: ['style'],
    childList: true
  });

  window.addEventListener('load', releaseOrphanedAliaLock);
})();
